// store/slices/financialModalSlice.js
import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const initialState = {
  open: false,
  localLoading: false,
  startDate: dayjs().startOf('year'),
  endDate: dayjs().endOf('month'),
  lastFetchedStartDate: null,
  lastFetchedEndDate: null,
  data: {
    profit: 0,
    incomes: 0,
    estimatedTax: 0,
    recommendedAdvancePercentage: 0
  }
};

const financialModalSlice = createSlice({
  name: 'financialModal',
  initialState,
  reducers: {
    resetFinancialModal: () => initialState,
    setFinancialModalOpen: (state, action) => {
      state.open = action.payload;
    },
    setFinancialModalLoading: (state, action) => {
      state.loading = action.payload;
    },
    setFinancialModalDateRange: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    setFinancialModalData: (state, action) => {
      state.data = action.payload;
      state.lastFetchedStartDate = state.startDate;
      state.lastFetchedEndDate = state.endDate;
    }
  }
});

export const {
  resetFinancialModal,
  setFinancialModalOpen,
  setFinancialModalLoading,
  setFinancialModalDateRange,
  setFinancialModalData
} = financialModalSlice.actions;

export default financialModalSlice.reducer;
